/* eslint-disable arrow-body-style */
import { forwardRef } from 'react';

const PDFHeader = forwardRef((props, ref) => {
	return (
		<div className="bg-white" ref={ref}>
			<div className="max-w-6xl mx-auto p-6 pb-0 bg-white">
				<div className="grid grid-cols-3 border-2 border-black">
					<div className="border-r-2 border-black p-3 flex items-center justify-center bg-white">
						<span className="text-red-600 font-bold text-base">
							J&J MedTech
						</span>
					</div>
					<div className="border-r-2 border-black p-3 flex items-center justify-center bg-gray-100">
						<h1 className="text-base font-bold text-center m-0">
							SMART – User Access Request Form
						</h1>
					</div>
					<div className="p-3 flex items-center justify-center bg-white">
						<div className="flex items-center gap-2">
							<span className="text-red-600 font-bold text-base">SMART</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});

PDFHeader.displayName = 'PDFHeader';

export default PDFHeader;
